import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../store/authStore';
import { loginService } from '../services/loginService';
import { authService } from '../../../services/authService';
import toast from 'react-hot-toast';

export const useLoginForm = () => {
  const navigate = useNavigate();
  const { login } = useAuthStore();
  const [email, setEmail] = useState('owner@blum.com');
  const [password, setPassword] = useState('owner123');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  // Captcha states
  const [captchaId, setCaptchaId] = useState('');
  const [captchaSvg, setCaptchaSvg] = useState('');
  const [captchaText, setCaptchaText] = useState('');

  const fetchCaptcha = async () => {
    try {
      const data = await authService.getCaptcha();
      setCaptchaId(data.captchaId);
      setCaptchaSvg(data.captchaSvg);
      setCaptchaText('');
    } catch (error) {
      toast.error('Failed to load CAPTCHA');
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!captchaText) {
      toast.error('Please enter the CAPTCHA');
      return;
    }

    setLoading(true);
    try {
      const res = await loginService.executeLogin({ email, password, captchaId, captchaText });
      if (res.success) {
        setCaptchaId('');
        setCaptchaSvg('');
        setCaptchaText('');
        login(res.data, res.token);
        toast.success(`Welcome back, ${res.data.name || res.data.firstName}!`);
        navigate('/home');
      } else {
        toast.error(res.message || 'Login failed');
        await fetchCaptcha();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Invalid email, password, or CAPTCHA');
      await fetchCaptcha();
    } finally {
      setLoading(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    loading,
    showPass,
    setShowPass,
    captchaText,
    setCaptchaText,
    captchaSvg,
    fetchCaptcha,
    handleLogin
  };
};
